<template>
  <div
    :class="[colorClasses]"
    class="p-2 text-xs/normal font-normal md:px-8 md:text-sm/normal">
    <slot v-if="$slots.default" />
  </div>
</template>
<script lang="ts" setup>
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    appearance?: "accent-orange" | "accent-green" | "surface-level-1";
  }>(),
  {
    appearance: "accent-orange",
  },
);

const colorClasses = computed(() => {
  const lookup = {
    "accent-orange": "bg-accent-orange text-neutral-primary",
    "accent-green": "bg-accent-green text-neutral",
    "surface-level-1": "bg-surface-level-1 shadow-sm",
  };
  return lookup[props.appearance];
});
</script>
